/**
 * クライアント採点の計測（docs/spec/observability.md §6.1, §6.2）。
 * `class.card.grade` span を作り、recordVerdict で判定（class.verdict と class.card.graded）を残す。
 * span は判定を画面に出すまで（apply の後、settle が終わるまで）開いておく。
 * 学習者の状態（箱・正答率・連続日数など）は属性に入れない。
 *
 * sandboxd で採点したもの（grading: 'server' のカードと、sandbox 経路で判定した fill-blank）は、
 * カード種別の側が class.card.grade と class.run を張り recordVerdict するので、ここでは計測しない。
 */
import type { Card } from '../../lib/cards';
import type { Verdict } from '../../lib/judge';
import { recordVerdict, withSpan } from '../../lib/telemetry';

export function isLocallyGraded(
  card: Pick<Card, 'grading'>,
  answer?: { kind: string; method?: 'local' | 'sandbox' },
): boolean {
  if (card.grading === 'server') return false;
  // fill-blank の一覧外の解答は sandboxd で判定する。カード側が class.card.grade と class.run を張る
  if (answer?.kind === 'fill-blank' && answer.method === 'sandbox') return false;
  return true;
}

export function traceLocalGrade(
  card: Pick<Card, 'id' | 'type'>,
  verdict: Verdict,
  apply: () => void,
  settle?: () => Promise<void> | void,
): Promise<void> {
  return withSpan(
    'class.card.grade',
    { 'class.card.id': card.id, 'class.card.kind': card.type, 'class.grade.method': 'local' },
    async (span) => {
      recordVerdict(span, { cardId: card.id, cardKind: card.type, method: 'local', verdict });
      apply();
      await settle?.();
    },
  );
}
